import React, { useContext } from 'react';
import { notification } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { SwapOutlined } from '@ant-design/icons';
import { updateBrokerStatus } from 'services/parametersService';
// import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { AuthContext } from 'components/Auth/Auth';
import ButtonOperation from 'components/ButtonOperation';

export type ActivateDisableBrokerButtonProps = ButtonProps & {
  mgid: number;
  associd: number;
  statusToUpdate: string;
  refetch: () => void;
};

const ActivateDisableBrokerButton: React.FC<
  ActivateDisableBrokerButtonProps
> = ({ size = 'small', refetch, statusToUpdate, mgid, associd, ...props }) => {
  // const { getComponentLabel } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);
  const status = statusToUpdate === 'ACTIVE' ? 'DISABLED' : 'ACTIVE';

  return (
    <ButtonOperation
      comcode={statusToUpdate === 'ACTIVE' ? 'Disable' : 'Active'}
      onClick={() => {
        !isInspect
          ? updateBrokerStatus({
              mgid,
              associd,
              status,
            }).then(() => {
              notification.success({ message: 'Broker updated' });
              refetch();
            })
          : (null as any);
      }}
      icon={<SwapOutlined />}
      {...props}
      size="large"
    />
    //   {/* {statusToUpdate === 'ACTIVE'
    //     ? getComponentLabel('disable')
    //     : getComponentLabel('activate')}
    // </Button> */}
  );
};

export default ActivateDisableBrokerButton;
